import { useRecoilTask } from 'recoil-toolkit';

import { loadedIncidentsUpdatesState } from './atoms';
import { getUpdatedIncidents } from './tasks';

export const useIncidentsUpdatesList = () => useRecoilTask(getUpdatedIncidents, [], {
  dataSelector: loadedIncidentsUpdatesState,
  errorStack: true,
});
